'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Text } from '@lichtblick/photon/atoms/text/text';
import { TextCTA } from '@lichtblick/photon/atoms/text-cta/text-cta';
import { CrossXs } from '@lichtblick/photon/icons/symbols/cross-xs';
import { Select } from '@lichtblick/photon/molecules/select';
import React, { useCallback, useEffect, useState } from 'react';
import { Job } from './job';
import styles from './job-overview.module.scss';
export const Filter = ({ areasOfWork, levelsOfExperience, locations, children })=>{
    const [areaOfWork, setAreaOfWork] = useState(null);
    const [level, setLevel] = useState(null);
    const [location, setLocation] = useState(null);
    useEffect(()=>{
        const params = new URLSearchParams(window.location.search);
        setAreaOfWork(params.get('bereich') ?? '');
        setLevel(params.get('erfahrung') ?? '');
        setLocation(params.get('ort') ?? '');
    }, []);
    const handleAreaChange = useCallback((e)=>{
        setAreaOfWork(e.currentTarget.value);
    }, []);
    const handleLevelChange = useCallback((e)=>{
        setLevel(e.currentTarget.value);
    }, []);
    const handleLocationChange = useCallback((e)=>{
        setLocation(e.currentTarget.value);
    }, []);
    const resetFilters = useCallback(()=>{
        setLevel('');
        setAreaOfWork('');
        setLocation('');
    }, []);
    useEffect(()=>{
        const params = new URLSearchParams();
        if (areaOfWork === null || level === null || location === null) {
            return;
        }
        if (areaOfWork) {
            params.append('bereich', areaOfWork);
        }
        if (level) {
            params.append('erfahrung', level);
        }
        if (location) {
            params.append('ort', location);
        }
        window.history.replaceState(null, '', `?${params.toString()}`);
    }, [
        areaOfWork,
        level,
        location
    ]);
    const jobs = React.Children.toArray(children).filter(({ props })=>{
        if (areaOfWork && props.areaOfWork !== areaOfWork) {
            return false;
        }
        if (level && props.levelOfExperience !== level) {
            return false;
        }
        if (location && !props.locations.includes(location)) {
            return false;
        }
        return true;
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.filters,
                children: [
                    /*#__PURE__*/ _jsx(Select, {
                        label: "Bereich",
                        onChange: handleAreaChange,
                        className: styles.select,
                        value: areaOfWork ?? '',
                        children: [
                            /*#__PURE__*/ _jsx(Select.Option, {
                                value: '',
                                children: "Alle"
                            }, ''),
                            ...areasOfWork.map((area)=>/*#__PURE__*/ _jsx(Select.Option, {
                                    value: area,
                                    children: area
                                }, area))
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Select, {
                        label: "Erfahrung",
                        onChange: handleLevelChange,
                        className: styles.select,
                        value: level ?? '',
                        children: [
                            /*#__PURE__*/ _jsx(Select.Option, {
                                value: '',
                                children: "Alle"
                            }, ''),
                            ...levelsOfExperience.map((level)=>/*#__PURE__*/ _jsx(Select.Option, {
                                    value: level,
                                    children: level
                                }, level))
                        ]
                    }),
                    Boolean(locations.length) && /*#__PURE__*/ _jsx(Select, {
                        label: "Ort",
                        onChange: handleLocationChange,
                        className: styles.select,
                        value: location ?? '',
                        children: [
                            /*#__PURE__*/ _jsx(Select.Option, {
                                value: '',
                                children: "Alle"
                            }, ''),
                            ...locations.map((location)=>/*#__PURE__*/ _jsx(Select.Option, {
                                    value: location,
                                    children: location
                                }, location))
                        ]
                    })
                ]
            }),
            (Boolean(areaOfWork) || Boolean(level) || Boolean(location)) && /*#__PURE__*/ _jsx(TextCTA, {
                as: "button",
                type: "button",
                onClick: resetFilters,
                icon: /*#__PURE__*/ _jsx(CrossXs, {}),
                slim: true,
                children: "Filter zurücksetzen"
            }),
            jobs.length ? /*#__PURE__*/ _jsx("ul", {
                className: styles['job-list'],
                children: jobs.map((child)=>/*#__PURE__*/ _jsx("li", {
                        children: /*#__PURE__*/ _createElement(Job, {
                            ...child.props,
                            key: child.props.uuid
                        })
                    }, child.props.uuid))
            }) : /*#__PURE__*/ _jsx(Text, {
                children: "Keine Ergebnisse"
            })
        ]
    });
};

//# sourceMappingURL=filter.js.map